import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './styles/adminlayout.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Admin components
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AdminLogin from './components/pages/AdminLogin';
import SignUpAdmin from './components/admin/signupadmin';
import Logout from './components/pages/Logout';
import BasicScienceAdmin from './components/admin/BasicScienceAdmin';
import CivilEngineeringAdmin from './components/admin/CivilEngineeeringAdmin';
import ComputerScienceAdmin from './components/admin/ComputerScienceAdmin';
import Dashboard from './components/admin/Dashboard';
import Departments from './components/admin/Departments';
import ElectricalEngineeringAdmin from './components/admin/ElectricalEngineeringAdmin';
import ElectronicsEngineeringAdmin from './components/admin/ElectronicsEngineeringAdmin';
import Gallery from './components/admin/Gallery';
import MechanicalEngineeringAdmin from './components/admin/MechanicalEngineeringAdmin';
import PhysicalEducationAdmin from './components/admin/PhysicalEducationAdmin';
import Placements from './components/admin/Placements';
import Sidebar from './components/admin/Sidebar';
import Navbar from './components/admin/Navbar';
import PublicationAdmin from './components/admin/PublicationAdmin';
import UploadPlacementImage from './components/admin/uploadePlacement';
import ManagePlacement from './components/admin/ManagePlacement';
import ImageUploaderCrop from './components/admin/ImageUploaderCrop';

// import Administration from './components/admin/Administration';

import DepartmentForm from './components/DepartmentForm';
import PlacementsManager from './components/admin/PlacementsManager';
import AddFacultyNonFaculty from './components/admin/addfaculty';
// User components
import Header from "./components/common/header/Header";
import Footer from "./components/common/footer/Footer";
import Home from "./components/home/Home";
import NewsAndEventsUser from "./components/home/NewsAndEventsUser";
import BasicScienceUser from './components/user/BasicScienceUser';
import CivilEngineerUser from './components/user/CivilEngineerUser';
import ElectricalEngineerUser from './components/user/ElectricalEngineerUser';
import ElectronicsEngineerUser from './components/user/ElectronicsEngineerUser';
import ComputerScienceUser from './components/user/ComputerScienceUser';
import MechanicalEngineerUser from './components/user/MechanicalEngineerUser';
import DashboardUser from './components/user/DashboardUser';
import GalleryUser from './components/user/GalleryUser';
import PlacementGallery from './components/user/PlacementGallery';
import PhysicalUser from './components/user/PhysicalUser';
import PublicationList from './components/user/PublicationList';
import CanteenGallery from './components/user/CanteenGallery';
import Contact from './components/contact/Contact';
import Administration from './components/admin/Administration';
import DepartmentDetails from './components/user/DepartmentDetails';
import ViewPlacementImage from './components/user/ViewPlacementImage';
import SeminarHall from './components/admin/SeminarHall';

// About components
import AboutPAPT from './components/user/AboutPAPT';

import History from './components/user/history';
import Mission from './components/user/mission';
import Principal from './components/user/principal';
import Chairman from './components/user/chairman';
import ManagingTrustee from './components/user/ManagingTrustee';
import AdministrationView from './components/user/AdministrationView';
import BoardOfTrustees from './components/user/leadership';


// Admission components
import Fitness from './components/admission/fitness';
import Hostel from './components/admission/hostel';
import Library from './components/admission/library';
import Transport from './components/admission/transport';
import ClassroomsLabsGallery from './components/admission/classrooms';
// AllCourses components
import CourseHome from './components/allcourses/CourseHome';
import CoursesCard from './components/allcourses/CoursesCard';
import OnlineCourses from './components/allcourses/OnlineCourses';
import NewsAndEvents from './components/admin/NewsAndEvents';

// Layout component for admin
const AdminLayout = ({ children }) => (
  <div className="admin-layout">
    <Navbar />
    <div className="content-wrapper">
      <Sidebar />
      <div className="main-content">{children}</div>
    </div>
  </div>
);

const App = () => {
  return (
    <Router>
      <Routes>
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/admin/logout" element={<Logout />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/placementsmanager"
          element={
            <ProtectedRoute>
          <AdminLayout>
            <PlacementsManager />
            </AdminLayout>
            </ProtectedRoute>}
        />
        <Route
          path="/admin/departments"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <Departments />
            </AdminLayout>
            </ProtectedRoute>
          }
        />
      
        <Route
          path="/admin/publication"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <PublicationAdmin />
            </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/administration"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <Administration/>
            </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/gallery"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <Gallery />
            </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/placements"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <Placements />
            </AdminLayout>
            </ProtectedRoute>
          }
        />
         <Route
          path="/admin/manageplacement"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <ManagePlacement />
            </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/imageuploadercrop"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <ImageUploaderCrop />
            </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/news"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <NewsAndEvents />
            </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/basicscience"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <BasicScienceAdmin />
            </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/physicaleducation"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <PhysicalEducationAdmin />
            </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/civilengineering"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <CivilEngineeringAdmin />
            </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/computerscience"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <ComputerScienceAdmin />
            </AdminLayout>
            </ProtectedRoute>

          }
        />
        <Route
          path="/admin/electricalengineering"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <ElectricalEngineeringAdmin />
            </AdminLayout>
            </ProtectedRoute>

          }
        />
        <Route
          path="/admin/mechanicalengineering"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <MechanicalEngineeringAdmin />
            </AdminLayout>
            </ProtectedRoute>

          }
        />
        <Route
          path="/admin/electronicsengineering"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <ElectronicsEngineeringAdmin />
            </AdminLayout>
            </ProtectedRoute>

          }
        />
        <Route
          path="/admin/departmentform"
          element={
            <ProtectedRoute>
            <AdminLayout>
              <DepartmentForm />
            </AdminLayout>
            </ProtectedRoute>

          }
        />
        <Route
          path="/admin/signup"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <SignUpAdmin />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/169placement"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <UploadPlacementImage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
        path="/admin/addfaculty"
        element={
          <ProtectedRoute>
          <AdminLayout>
            <AddFacultyNonFaculty/>
          </AdminLayout>
            </ProtectedRoute>

        }
        />
        {/* User Routes */}
        <Route path="/" element={<><Header /><Home /><Footer /></>} />
<Route path="/department/:name" element={<><Header /><DepartmentDetails /><Footer /></>} />
<Route path="/basicscienceuser" element={<><Header /><BasicScienceUser /><Footer /></>} />
<Route path='/civilengineeruser' element={<><Header /><CivilEngineerUser /><Footer /></>} />
<Route path='/computerscienceuser' element={<><Header /><ComputerScienceUser /><Footer /></>} />
<Route path='/electricalengineeruser' element={<><Header /><ElectricalEngineerUser /><Footer /></>} />
<Route path='/electronicsengineeruser' element={<><Header /><ElectronicsEngineerUser /><Footer /></>} />
<Route path='/physicaleducationuser' element={<><Header /><PhysicalUser /><Footer /></>} />
<Route path='/mechanicalengineeruser' element={<><Header /><MechanicalEngineerUser /><Footer /></>} />
<Route path='/publicationuser' element={<><Header/><PublicationList/><Footer/></>} />
<Route path='/placementgallery' element={<><Header/><PlacementGallery/><Footer/></>}/>
<Route path='/169placement' element={<><Header/><ViewPlacementImage/><Footer/></>}/>
<Route path='/canteen' element={<><Header/><CanteenGallery/><Footer/></>} />
<Route path="/gallery" element={<><Header /><GalleryUser /><Footer /></>} />
<Route path="/placements" element={<><Header /><PlacementGallery /><Footer /></>} />
<Route path="/news" element={<><Header /><NewsAndEventsUser /><Footer /></>} />
<Route path="/dashboarduser" element={<><Header /><DashboardUser /><Footer /></>} />
<Route path="/Contact" element={<><Header /><Contact /><Footer /></>} />
<Route path="/SeminarHall" element={<><Header /><SeminarHall /><Footer /></>} />

{/* About Pages */}
<Route path="/papt" element={<><Header/><AboutPAPT/><Footer/></>}/>

<Route path="/history" element={<><Header /><History /><Footer /></>} />
<Route path="/mission" element={<><Header /><Mission /><Footer /></>} />
<Route path="/principal" element={<><Header /><Principal /><Footer /></>} />
<Route path="/chairman" element={<><Header /><Chairman /><Footer /></>} />
<Route path="/managingtrustee" element={<><Header /><ManagingTrustee /><Footer /></>} />
<Route path="/administration" element={<><Header /><AdministrationView/><Footer /></>} />
<Route path="/leadership" element={<><Header /><BoardOfTrustees /><Footer /></>} />
{/* Admission Pages */}
<Route path="/admission/fitness" element={<><Header /><Fitness /><Footer /></>} />
<Route path="/admission/hostel" element={<><Header /><Hostel /><Footer /></>} />
<Route path="/admission/library" element={<><Header /><Library /><Footer /></>} />
<Route path="/admission/transport" element={<><Header /><Transport /><Footer /></>} />
<Route path="/admission/classrooms" element={<><Header /><ClassroomsLabsGallery /><Footer /></>} />
{/* AllCourses Pages */}
<Route path="/courses" element={<><Header /><CourseHome /><Footer /></>} />
<Route path="/courses/card" element={<><Header /><CoursesCard /><Footer /></>} />
<Route path="/courses/online" element={<><Header /><OnlineCourses /><Footer /></>} />

        {/* Default Route */}
        <Route path="/" element={<Navigate to="/home" />} />

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;
